export enum ConditionEnum {
    NEW, USED
}